import type { FC, SVGProps } from "react";

const IconStructure: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M6.33325 18.3334V12.8584" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 9.1665H8.00833" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 5.8335H8.00833" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.66675 12.8584V18.3334" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 13.3333C9.77877 12.7924 8.90154 12.5 8 12.5C7.09846 12.5 6.22123 12.7924 5.5 13.3333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.3333 9.1665H11.3416" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.3333 5.8335H11.3416" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.66675 9.1665H4.67508" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.66675 5.8335H4.67508" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.9999 1.6665H2.99992C2.07944 1.6665 1.33325 2.4127 1.33325 3.33317V16.6665C1.33325 17.587 2.07944 18.3332 2.99992 18.3332H12.9999C13.9204 18.3332 14.6666 17.587 14.6666 16.6665V3.33317C14.6666 2.4127 13.9204 1.6665 12.9999 1.6665Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconStructure;
